// extracted by mini-css-extract-plugin
export default {"title":"Impressum_title__2q85I","impressumContent":"Impressum_impressumContent__b5qSK"};